<template>
  <div id="wrapper" :class="{ fallback: notFound || !avatar }">
    <img class="avatar" :src="img" @error="notFound = true" />
    <template v-if="enableEdit">
      <div class="button-wrapper">
        <DecoratedButton @click="show = true" class="plain">
          <Icon
            type="camera"
            :rounded="true"
            backgroundColor="#fff"
            color="#000"
            borderColor="#000"
            padding="10px"
          />
        </DecoratedButton>
      </div>
      <Edit :show="show" @close="show = false" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Edit from "@/components/pages/profile/modals/profile/avatar/Edit";

export default {
  name: "profile-avatar",
  components: { Edit },
  props: {
    fallback: {
      type: String,
      default: "/static/images/icons/profile.png"
    },
    size: {
      type: Number,
      default: 151
    },
    enableEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      show: false,
      notFound: false
    };
  },
  computed: {
    ...mapGetters("user", {
      avatar: "getAvatar"
    }),
    img() {
      if (this.avatar && !this.notFound) {
        let query = this.avatar.indexOf("?") >= 0 ? "" : "?";
        query += "&r=r&s=" + this.size + "&d=404";
        return this.avatar + query;
      }

      return this.fallback;
    }
  },
  watch: {
    avatar() {
      this.notFound = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#wrapper {
  position: relative;
  display: inline-block;

  .button-wrapper {
    position: absolute;
    top: -15px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  &:not(.fallback) {
    .button-wrapper {
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .avatar {
    border: none;
    max-width: 100%;
    height: auto;
    border-radius: 50%;
  }

  &.fallback {
    .avatar {
      border-radius: 0;
    }
  }
}
</style>
